import React from 'react';
import { ExclamationTriangle, Inbox, WifiOff } from 'react-bootstrap-icons';

/**
 * Shared empty / error presentation so a failed request never leaves
 * the user staring at a blank screen with no way forward.
 */
const ICONS = {
  empty: Inbox,
  error: ExclamationTriangle,
  offline: WifiOff,
};

const StateBlock = ({
  variant = 'empty',
  title,
  message,
  actionLabel,
  onAction,
  children,
}) => {
  const Icon = ICONS[variant] || Inbox;

  return (
    <div className="state-block" role={variant === 'error' ? 'alert' : undefined}>
      <span className="state-block__icon">
        <Icon size={28} aria-hidden="true" />
      </span>
      {title && <h2 className="state-block__title">{title}</h2>}
      {message && <p className="state-block__message">{message}</p>}
      {children}
      {actionLabel && onAction && (
        <button type="button" className="btn btn--primary" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default StateBlock;
